import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate} from "react-router-dom";
import { HashLoader } from "react-spinners";
import Failuremessage from "./failuremessage";


export default function Login(props){
    const navigate = useNavigate();
    const [res,setRes] = useState();
    const [loading,setLoading] = useState(false);
    const [formData,setFormData] = useState({
        username:"",
        password:""
    })
    const rootUrl = "http://localhost:3000";
    const localrootUrl = "https://ahkserver.onrender.com";

    function handleSubmit(event){
        event.preventDefault();
        setLoading(true);
        const fetchData = async ()=>{
            try{
            const dataposter = await axios.post(`${localrootUrl}/login`,formData,{withCredentials:true});
            const response = dataposter.data;
            setRes(response);
            setLoading(false);
            console.log(res);
            }catch(error){
                console.log(error);
            }
        }
        fetchData();
    }


    useEffect(()=>{
        if(res){
            if(res.isAuth){
                navigate('/uploadReports');
            }
        }
    },[res])


   
        return <div class="container mt-5">
        {loading?<HashLoader size={50} className="newloader" loading={loading}/>:res?res.failure?<Failuremessage custommessage={res.failure} isFail={true}/>:<Failuremessage successmessage={res.success} isFail={false}/>:<h1 className="updates">Login</h1>}
        <div class="row">
          <div class="col-sm-8">
            <div class="card">
              <div class="card-body">
                <form onSubmit={handleSubmit} method="POST">
                  <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" value={formData.username} onChange={(event)=>{setFormData((prevVal)=>{return {...prevVal,username:event.target.value}})}} class="form-control" name="username"/>
                  </div>
                  <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" value={formData.password} onChange={(event)=>{setFormData((prevVal)=>{return {...prevVal,password:event.target.value}})}} class="form-control" name="password"/>
                  </div>
                  <button type="submit" style={{width:"auto"}} class="submit">Login</button>
                </form>
              </div>
            </div>
          </div>
          </div>
          </div>
}